module.exports = __webpack_public_path__ + "static/media/all_cuff.fe7f750f.svg";